<template>
  <div>
    <div class="header">
      <div>
        <p>Sweeper 111</p>
        <p>{{ this.$t("sweeper111.sweeper111") }}</p>
      </div>
    </div>
    <div class="content">
      <video
        controls
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        x5-playsinline
        width="100%"
        src="https://enway-official.s3.ap-northeast-1.amazonaws.com/enway-video/2-5/S111.40331f10.mp4"
      ></video>
    </div>
    <div class="footer">
      <img
        width="100%"
        src="../../assets/sweeper111/Specifications-Img-Vacuum-40-min-1.0591186c.png"
        alt=""
      />
      <p class="title">{{ this.$t("sweeper111.Sweeper111Specification") }}</p>
      <ul class="item-list">
        <li>
          <p>{{ this.$t("sweeper111.ProductSize") }}</p>
          <p>1530（L）* 1010（W）* 1400（H）mm</p>
        </li>
        <li>
          <p>{{ this.$t("sweeper111.BatteryCapacity") }}</p>
          <p>Li-ion 240 Ah</p>
        </li>
        <li>
          <p>{{ this.$t("sweeper111.ContinuousUptime") }}</p>
          <p>4-7 h</p>
        </li>
        <li>
          <p>{{ this.$t("sweeper111.KiyoaraiWidth") }}</p>
          <p>1100 mm</p>
        </li>
        <li>
          <p>{{ this.$t("sweeper111.TurningAngle") }}</p>
          <p>±60°</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.header {
  background: url("../../assets/sweeper111/Smart-Obstacle-Avoidance-D.-min.7b920454.png")
    no-repeat center;
  background-size: cover;
  height: 56vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 15.4667vw;
    margin-left: 19.2vw;
  }
  p {
    font-family: "Meiryooo";
    color: #ffffff;
  }
  p:first-child {
    font-size: 7.4667vw;
    font-weight: bold;
    line-height: 7.2vw;
  }
  p:last-child {
    font-size: 3.7333vw;
    font-weight: 500;
    line-height: 5.0667vw;
  }
}
.content {
  video {
    vertical-align: bottom;
  }
}
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    margin: 4vw 0;
  }
  .item-list {
    li {
      display: flex;
      margin: 0 9.0667vw;
      margin-bottom: 3.2vw;
      p {
        font-size: 3.2vw;
        font-family: "Meiryooo";
        line-height: 5.3333vw;
      }
      p:first-child {
        flex-shrink: 0;
        width: 23vw;
        color: #000;
        text-align: right;
        margin-right: 2.6667vw;
      }
      p:last-child {
        color: #0064e6;
      }
    }
    li:nth-child(2) {
      p:first-child {
        width: 28vw;
        margin-left: -5vw;
      }
    }
    li:last-child {
      margin-bottom: 10.6667vw;
    }
  }
}
</style>
